import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Truncate from 'react-truncate';
import SiteLoader from '../layout/site-loader';
import PageTitle from '../common/page-title/index';
import BannerCarousel from '../home/banner-carousel/banner-carousel';
import ImageSlider from '../common/image-slider/image-slider';
import ArrowButton from '../common/button-arrow';
import { Cancel, Giftbox, Alert } from '../common/icons';
import InlineCKEditor from '../common/editor/inline-editor';
import irelandApi from '../../irelandApi';

import './styles.css';

const New = () => <span>New</span>;

const LABELS = [
  {
    id: 'discontinued',
    className: 'is-discontinued',
    text: 'Discontinued',
    icon: Cancel,
    check: attributes => attributes['stock-status'] === 'Discontinued'
  },
  {
    id: 'out-of-stock',
    className: 'is-out-of-stock',
    text: 'Out of Stock',
    icon: Alert,
    check: attributes => attributes['stock-status'] === 'Out of Stock'
  },
  {
    id: 'new',
    className: 'is-new',
    icon: New,
    check: attributes => attributes['special-new']
  },
  {
    id: 'reward',
    className: 'is-reward',
    text: 'Reward',
    icon: Giftbox,
    check: attributes => attributes['special-reward']
  },
];

const Product = ({ id, attributes, photo, isBluBar }) => {
  const labels = LABELS.filter(({ check }) => check(attributes));
  const brandItemClassName = isBluBar ? 'product-brand-item-blu-bar' : 'product-brand-item';

  return (
    <div className={brandItemClassName}>
      <Link to={`/order/new?searchQuery=${attributes.name}`} className="product-brand-link">
        <ArrowButton arrow={false} ghost={true} color="white" submit={false}>CLICK TO ORDER</ArrowButton>
      </Link>

      {!isBluBar && Boolean(labels.length) && (
        <div className="product-brand-labels">
          {labels.map(({ id, className, text, icon: Icon }) => (
            <span key={id} className={`product-brand-label ${className}`}>
              <span className="product-brand-icon"><Icon /></span>
              {" "}
              {text}
            </span>
          ))}
        </div>
      )}

      <img src={photo} alt={attributes.name} />

      {!isBluBar && <h3 className="product-brand-name">
        <Truncate lines={2}>{attributes.name}</Truncate>
      </h3>}
    </div>
  );
}

class BrandPage extends Component {
  state = { brand: null, carousel: null, productImages: [] };

  fetchBrand() {
    const { params: { slug }} = this.props.match;

    irelandApi.get(`/api/brands/${slug}`).then(({ data: brand }) => {
      const { id, attributes, links, name } = brand.data;
      const products = (brand.included || []).filter(({ type }) => type === 'products');
      const isBluBar = attributes['is-blu-bar'];

      this.setState({
        brand,
        carousel: [{
          id: `brand-${id}`,
          title: attributes['banner-title'],
          text: attributes['banner-text'],
          text_color: attributes['banner-text-colour'],
          button_color: attributes['banner-text-colour'],
          button_label: 'ORDER NOW',
          button_link: `/order/new?searchQuery=${attributes.name}`,
          link: { image: links.banner },
          css_tag_attributes: {},
          javascript_tag_attributes: {}
        }],
        productImages: products.map(({ id, attributes, links }) => ({
          inner: <Product id={id} attributes={attributes} photo={links.photo} isBluBar={isBluBar} />
        }))
      })
    });
  }

  componentDidMount() {
    this.fetchBrand()
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.slug !== prevProps.match.params.slug) {
      this.setState({ brand: null, carousel: null, productImages: [] });
      this.fetchBrand();
    }
  }

  render() {
    const { brand, carousel, productImages } = this.state;

    if (!brand) return <SiteLoader/>;

    const {
      data: { id, attributes: { name } },
      meta: { contents: [pageContent]}
    } = brand;

    return (
      <div>
        <PageTitle pageTitle={`Brands - ${name}`} />

        <div className="home-slide">
          <BannerCarousel carousels={carousel} carouselSpeed={0} isLargeBanner />
        </div>

        {Boolean(productImages.length) && (
          <div className="brand-products">
            <ImageSlider
              data={productImages}
              title={`${name.toUpperCase()} PRODUCTS`}
              rows={1}
            />
          </div>
        )}

        <div className="brand-page-content">
          <InlineCKEditor
            identifier={`brand-content-${id}`}
            contents={pageContent}
          />
        </div>
      </div>
    );
  }
}

export default BrandPage;



// WEBPACK FOOTER //
// ./src/components/brand-page/index.jsx